import React from "react";
import Colors from "../../Assets/Styles/Colors";
import { Button, CircularProgress } from "@mui/material";

export const PrimaryButton = (props) => {
  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        bgcolor: Colors.primary,
        textTransform: "capitalize",
        minWidth: "100px",
        boxShadow:
          "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
      }}
    >
      {props.loading ? (
        <CircularProgress color="inherit" size={24} />
      ) : (
        props.title
      )}
      {/* {props.title} */}
    </Button>
  );
};

export const SecondaryButton = (props) => {
  return (
    <Button
      variant="contained"
      {...props}
      sx={{
        bgcolor: Colors.secondary,
        textTransform: "capitalize",
        minWidth: "100px",
        boxShadow:
          "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
      }}
    >
      {props.title}
    </Button>
  );
};
